import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=64f66642"
import script from "./Abstract.vue?vue&type=script&lang=js"
export * from "./Abstract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports